import React from 'react'
import { useParams } from 'react-router-dom';
import ReportPSPM from '../components/ReportPSPM';
import ReportESPM from '../components/ReportESPM';

export default function ReportPublic() {
    let { type } = useParams();

    return (
        type === "pspm" ? <ReportPSPM /> : <ReportESPM />
    )
}
